<div class="chart-container">
  @if (config.title) {
    <h4 class="chart-title">{{ config.title }}</h4>
  }
  <div (resized)="observeResize($event)" bshResizeObserver style="height: 100%">
    @if (chartData.length === 0) {
      <div class="no-data-message">
        <p>No data available for this chart.</p>
      </div>
    }
    <svg
      [attr.width]="width"
      [attr.height]="height"
      [style.min-width.px]="minSvgWidth"
      [style.display]="chartData.length === 0 ? 'none' : 'block'">
      <g
        [attr.transform]="
          'translate(' + renderMargin.left + ',' + renderMargin.top + ')'
        ">
        <!-- Scales -->
        <g
          bshScale
          #mainScale="bshScale"
          [type]="'band'"
          [domain]="groups"
          [range]="mainScaleRange"
          [padding]="0.1"></g>
        <g
          bshScale
          #subScale="bshScale"
          [type]="'band'"
          [domain]="subgroups"
          [range]="[0, mainScale.bandwidth]"
          [padding]="0.05"></g>
        <g
          bshScale
          #valueScale="bshScale"
          [type]="'linear'"
          [domain]="valueScaleDomain"
          [range]="valueScaleRange"></g>

        <!-- Axes -->
        <g
          bshAxis
          [scale]="scale('bottom')"
          [hideLabels]="isAxisDataHidden('bottom')"
          [hideTicks]="isAxisDataHidden('bottom')"
          [orient]="'bottom'"
          [tickFormat]="tickFormat"
          [attr.transform]="'translate(0,' + chartHeight + ')'"></g>
        <g
          bshAxis
          [scale]="scale('left')"
          [orient]="'left'"
          [tickFormat]="tickFormat"
          [hideLabels]="isAxisDataHidden('left')"
          [hideTicks]="isAxisDataHidden('left')"></g>

        <!-- Subgroup Labels -->
        @if (config.showSubgroupLabels) {
          @for (d of groups; track d) {
            <g [attr.transform]="groupLabelTransform(d)">
              @for (key of subgroups; track key) {
                @let position = subgroupLabelAttributes(key);
                <text
                  [attr.text-anchor]="position.anchor"
                  [attr.transform]="
                    subgroupLabelTransform(position.x, position.y)
                  "
                  font-size="12"
                  fill="#666">
                  {{ key }}
                </text>
              }
            </g>
          }
        }

        <!-- Grid Lines -->
        <g>
          @if (config.showGridLines) {
            @for (tick of valueScale.ticks(); track tick) {
              @let linePosition = gridLineAttributes(tick);
              <line
                [attr.x1]="linePosition.x1"
                [attr.x2]="linePosition.x2"
                [attr.y1]="linePosition.y1"
                [attr.y2]="linePosition.y2"
                stroke="#e0e0e0"
                stroke-width="1"
                shape-rendering="crispEdges" />
            }
          }
        </g>

        <!-- Bars and Values -->
        @for (d of chartData; track d.group) {
          @let visibleSubgroups = getVisibleSubgroups(d);
          @if (visibleSubgroups.length > 0) {
            <g [attr.transform]="barTransform(d)">
              @for (key of visibleSubgroups; track key) {
                @let bar = barAttributes(key, d);
                <rect
                  [attr.x]="bar.x"
                  [attr.y]="bar.y"
                  [attr.width]="bar.width"
                  [attr.height]="bar.height"
                  [attr.fill]="bar.fill"></rect>
                @if (config.showSubgroupValues) {
                  <text
                    [attr.x]="bar.valueX"
                    [attr.y]="bar.valueY"
                    [attr.text-anchor]="bar.anchor"
                    font-size="10"
                    fill="#000">
                    {{ d[key] }}
                  </text>
                }
              }
            </g>
          }
        }
      </g>
      <!-- Legend -->
      <g
        bshLegend
        [subgroups]="subgroups"
        [colors]="config.colors"
        [spacing]="legendSpacing"
        [legendWidth]="legendWidth"
        [legendX]="legendX"
        [legendY]="legendY"
        [visible]="config.showLegend"></g>
    </svg>
  </div>
</div>
